import {
  GoogleMap,
  InfoWindow,
  Marker,
  MarkerClusterer,
  OverlayView,
  StreetViewPanorama
} from '@react-google-maps/api';
import { useRef, useState } from 'react';
import { FaWalking } from 'react-icons/fa';
import { MdOutlineSocialDistance, MdOutlineStar } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { getGeocode } from 'use-places-autocomplete';
import { Get } from '../../Axios/AxiosFunctions';
import { BaseURL } from '../../config/apiUrl';
import { defaultLocation } from '../../constant/commonData';
import {
  business,
  businessMapIcon,
  cafe,
  cafeMapIcon,
  cluster,
  commuteIcon,
  commuteMapIcon,
  gym,
  gymMapIcon,
  healthMapIcon,
  hospital,
  hotelMapIcon,
  mall,
  mallMapIcon,
  mapMarker2,
  market,
  MarketMapIcon,
  park,
  parkMapIcon,
  restaurant,
  school,
  schoolIcon,
  worship,
  worshipMapIcon
} from '../../constant/imagePath';
import { usdToOther } from '../../utils/helpers';
import EventCard from '../EventCard';
import LottieLoader from '../LottieLoader/LottieLoader';
import ProjectCard from '../ProjectCard';
import PropertyCard from '../PropertyCard';
import classes from './MainMain.module.css';

const optionsOP = {
  imagePath:
    'https://web.archive.org/web/20230701011019/https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m', // so you must have m1.png, m2.png, m3.png, m4.png, m5.png and m6.png in that folder,
  styles: [
    {
      url: cluster,
      height: 64,
      width: 64,
      textColor: 'white',
      textSize: 14
    }
  ]
};

const TurkeyBounds = {
  north: 42.107614,
  south: 35.808592,
  west: 25.664641,
  east: 44.793989
};

const isWithinTurkey = (lat, lng) => {
  return (
    lat <= TurkeyBounds.north &&
    lat >= TurkeyBounds.south &&
    lng >= TurkeyBounds.west &&
    lng <= TurkeyBounds.east
  );
};

export default function Map({
  location,
  className = '',
  zoom,
  options = {},
  isPanorama,
  mapProperties,
  setMapProperties,
  showLandMarks = false,
  draggable = false,
  getDraggedAddress,
  showMarker = true,
  markerIcon = null
}) {
  const mapRef = useRef(null);
  const { currency } = useSelector((state) => state.converterReducer);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedPlace, setSelectedPlace] = useState(null);
  // console.log(selectedPlace, 'selectedPlace');
  const [landMarks, setLandMarks] = useState({
    school: false,
    hospital: false,
    park: false,
    business: false,
    market: false,
    mall: false,
    worship: false,
    restaurant: false,
    cafe: false,
    gym: false,
    bus_station: false
  });
  const [landMarksData, setLandMarksData] = useState({
    school: [],
    hospital: [],
    park: [],
    business: [],
    market: [],
    mall: [],
    worship: [],
    restaurant: [],
    cafe: [],
    gym: [],
    bus_station: []
  });
  const [currentZoom, setCurrentZoom] = useState(zoom || 14); // fallback to passed zoom
  const getLandMarksData = async (type) => {
    const url = BaseURL(`map?lat=${location.lat}&lng=${location.lng}&type=${type}`);
    setIsLoading(true);
    const res = await Get(url);
    setIsLoading(false);
    if (res && res.data?.data?.length > 0) {
      // fit bounds
      const bounds = new window.google.maps.LatLngBounds();
      res.data?.data.forEach((landMark) => {
        bounds.extend(landMark?.location);
      });
      mapRef.current.fitBounds(bounds);
      // set zoom level to 16
      // mapRef.current.setZoom(16);
      setCurrentZoom(16);

      setLandMarksData({ ...landMarksData, [type]: res.data?.data });
    }
  };

  const getDistance = async (origin, destination) => {
    const service = new window.google.maps.DistanceMatrixService();
    return new Promise((resolve, reject) => {
      service.getDistanceMatrix(
        {
          origins: [origin],
          destinations: [destination],
          travelMode: 'WALKING'
        },
        (response, status) => {
          if (status === 'OK') {
            resolve({
              distance: response.rows[0].elements[0].distance.text,
              duration: response.rows[0].elements[0].duration.text
            });
          } else {
            reject('Error was: ' + status);
          }
        }
      );
    });
  };
  const markerIconWidth = 80; // Specify your icon's width
  const markerIconHeight = 80; // Specify your icon's height
  const mapStyles = [
    {
      featureType: 'poi',
      elementType: 'all',
      stylers: [{ visibility: 'off' }]
    }
  ];
  return (
    <div className={`${classes?.container} ${className}`}>
      {/* Map */}
      <GoogleMap
        ref={mapRef}
        onLoad={(map) => {
          mapRef.current = map;
        }}
        onZoomChanged={() => {
          if (mapRef.current) {
            const zoomLevel = mapRef.current.getZoom();
            const landmarksData = Object.keys(landMarksData).map((landMark) => {
              return landMarksData[landMark].length;
            });
            if (landmarksData.length > 0 && zoomLevel >= 12) {
              return setCurrentZoom(16);
            }
            setCurrentZoom(zoomLevel);
          }
        }}
        zoom={zoom}
        center={location}
        options={{
          ...options,
          mapTypeControl: true,
          fullscreenControl: true,
          styles: mapStyles
          // styles: [
          //   {
          //     featureType: 'poi',
          //     elementType: 'labels',
          //     stylers: [{ visibility: 'off' }]
          //   }
          // ]
        }}
        mapContainerClassName={classes['map-container']}>
        {isPanorama && (
          <StreetViewPanorama
            position={location}
            visible={true}
            options={{
              // show buttons to move
              addressControl: true,
              linksControl: true,
              panControl: true,
              enableCloseButton: false,
              fullscreenControl: true,
              zoomControl: true,
              motionTracking: true,
              motionTrackingControl: true,
              movementTracking: true,

              pov: {
                heading: 34,
                pitch: 10
              }
            }}
          />
        )}
        {location && showMarker && (
          <>
            <Marker
              position={location}
              // icon={markerIcon ? markerIcon : mapMarker2

              // }
              icon={{
                url: markerIcon ? markerIcon : mapMarker2,
                ...(markerIcon
                  ? {
                      anchor: new window.google.maps.Point(
                        markerIconWidth / 2,
                        markerIconHeight / 2
                      ), // Center the icon
                      scaledSize: new window.google.maps.Size(markerIconWidth, markerIconHeight) // Set the size of the icon
                    }
                  : {})
                // anchor: new window.google.maps.Point(markerIconWidth / 2, markerIconHeight / 2), // Center the icon
                // scaledSize: new window.google.maps.Size(markerIconWidth, markerIconHeight) // Set the size of the icon
              }}
              draggable={draggable}
              onDragEnd={(e) => {
                // get address [reverse geocoding]
                const _location = {
                  lat: e.latLng.lat(),
                  lng: e.latLng.lng()
                };
                // only turkey address
                if (isWithinTurkey(_location.lat, _location.lng)) {
                  getGeocode({ location: _location }).then((results) => {
                    getDraggedAddress &&
                      getDraggedAddress({
                        lat: e.latLng.lat(),
                        lng: e.latLng.lng(),
                        address: results[0].formatted_address
                      });
                  });
                  return;
                } else {
                  getDraggedAddress &&
                    getDraggedAddress({
                      ...defaultLocation,
                      address: ''
                    });
                }
              }}
            />
          </>
        )}

        {/* render properties on map in a clustered way */}
        <MarkerClusterer
          zoomOnClick={false}
          options={{
            ...optionsOP
          }}
          onClick={(cluster) => {
            const latLng = cluster.markers.map((marker) => ({
              lat: marker.getPosition().lat(),
              lng: marker.getPosition().lng()
            }));
            const foundProperties = latLng.map((latLng) =>
              findProperties(latLng.lat, latLng.lng, mapProperties)
            );

            // zoom to bounds
            const bounds = new window.google.maps.LatLngBounds();
            foundProperties.forEach((property) => {
              bounds.extend({
                lat: property?.location?.coordinates?.[1],
                lng: property?.location?.coordinates?.[0]
              });
            });
            mapRef.current.fitBounds(bounds, 100);

            setMapProperties && setMapProperties(foundProperties);
          }}>
          {(clusterer) =>
            mapProperties?.map((location) => {
              const coordinates = {
                lat: location?.location?.coordinates?.[1],
                lng: location?.location?.coordinates?.[0]
              };

              return (
                // <>
                //   {' '}
                //   <Marker
                //     label={{
                //       text: `$ ${location.price}`,
                //       fontSize: '14px',

                //       className: classes.customMarkerLabel // Apply styles from MainMain.module.css
                //     }}
                //     onClick={(a) => {
                //       setSelectedPlace(
                //         findProperties(a?.latLng?.lat(), a?.latLng?.lng(), mapProperties)
                //       );
                //       const foundProperty = findProperties(
                //         coordinates.lat,
                //         coordinates.lng,
                //         mapProperties
                //       );
                //       setMapProperties && setMapProperties([foundProperty]);
                //     }}
                //     key={createKey(coordinates)}
                //     position={coordinates}
                //     clusterer={clusterer}
                //     icon={mapMarker2}></Marker>
                // </>
                <>
                  {/* Marker */}
                  {/* <Marker
                   
                    position={coordinates}
                    clusterer={clusterer}
                    icon={mapMarker2}
                  /> */}

                  {/* Custom Label */}
                  <OverlayView
                    clusterer={clusterer}
                    key={createKey(coordinates)}
                    position={coordinates}
                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
                    <div
                      className={classes.customMarkerLabel}
                      style={{
                        position: 'absolute',
                        borderRadius: '40px',
                        padding: '2px 10px',
                        border: '2px Solid #fff',
                        cursor: 'pointer',
                        backgroundColor: '#00A997'
                      }}
                      onClick={() => {
                        const foundProperty = findProperties(
                          coordinates.lat,
                          coordinates.lng,
                          mapProperties
                        );

                        if (foundProperty) {
                          setSelectedPlace(foundProperty);
                          setMapProperties && setMapProperties([foundProperty]);
                        } else {
                          console.warn('No property found for the provided coordinates');
                        }
                      }}>
                      {usdToOther({ amount: location?.price, ...currency })}
                    </div>
                  </OverlayView>
                </>
              );
            })
          }
        </MarkerClusterer>

        {/* if selected place, show info window */}
        {selectedPlace && (
          <InfoWindow
            key={`${selectedPlace?.location?.coordinates?.[1] || selectedPlace?.location?.lat}-${
              selectedPlace?.location?.coordinates?.[0] || selectedPlace?.location?.lng
            }`}
            className={classes.infoWindow}
            position={{
              lat: selectedPlace?.location?.coordinates?.[1] || selectedPlace?.location?.lat,
              lng: selectedPlace?.location?.coordinates?.[0] || selectedPlace?.location?.lng
            }}
            onCloseClick={() => {
              // setMapProperties(mapProperties);
              setSelectedPlace(null);
            }}>
            <>
              <div
                style={{
                  padding: '0px',
                  overflow: 'hidden',
                  // width: '250px',

                  maxHeight: '700px',
                  backgroundColor: 'transparent'
                }}>
                {/* <p>abc</p> */}
                {selectedPlace?.type === 'event' && <EventCard type={'map'} data={selectedPlace} />}
                {selectedPlace?.type === 'property' && (
                  <PropertyCard type="map" data={selectedPlace} />
                )}
                {selectedPlace?.type === 'project' && (
                  <ProjectCard type="map" data={selectedPlace} />
                )}
                {selectedPlace?.type === 'landMark' && (
                  <div
                    style={{
                      padding: '10px 10px 18px'
                    }}>
                    <h5 style={{ color: '#000', fontSize: '14px' }} className="t-t-c">
                      {selectedPlace?.name}
                    </h5>
                    <p className="mb-2 mt-2 me-2">{selectedPlace?.address}</p>
                    <p className="mb-2">
                      <b>
                        <MdOutlineStar color="var(--primary-clr)" size={18} />
                      </b>{' '}
                      {selectedPlace?.rating}
                    </p>
                    <p className="mb-2">
                      <b>
                        <MdOutlineSocialDistance color="var(--primary-clr)" size={18} />
                      </b>{' '}
                      {selectedPlace?.distance || 'N/A'}
                    </p>
                    <p>
                      <b>
                        <FaWalking color="var(--primary-clr)" size={18} />
                      </b>{' '}
                      {selectedPlace?.duration || 'N/A'}
                    </p>
                  </div>
                )}
              </div>
            </>
          </InfoWindow>
        )}

        {/* render landmarks when visibility is true and length > 0 */}
        {Object.keys(landMarksData).map((landMark) => {
          return landMarks[landMark] &&
            landMarksData[landMark] &&
            landMarksData[landMark].length &&
            currentZoom >= 15
            ? landMarksData[landMark].map((landMarkData, index) => {
                return (
                  <Marker
                    key={index}
                    position={{
                      lat: landMarkData?.location?.lat,
                      lng: landMarkData?.location?.lng
                    }}
                    title={landMarkData?.name}
                    icon={
                      landMark === 'school'
                        ? schoolIcon
                        : landMark === 'hospital'
                        ? healthMapIcon
                        : landMark === 'park'
                        ? parkMapIcon
                        : landMark === 'market'
                        ? MarketMapIcon
                        : landMark === 'mall'
                        ? mallMapIcon
                        : landMark === 'worship'
                        ? worshipMapIcon
                        : landMark === 'restaurant'
                        ? hotelMapIcon
                        : landMark === 'cafe'
                        ? cafeMapIcon
                        : landMark === 'business'
                        ? businessMapIcon
                        : landMark === 'gym'
                        ? gymMapIcon
                        : landMark === 'bus_station'
                        ? commuteMapIcon
                        : ''
                    }
                    onClick={async () => {
                      setIsLoading(true);
                      const distanceAndDuration = await getDistance(location, {
                        lat: landMarkData?.location?.lat,
                        lng: landMarkData?.location?.lng
                      });
                      setIsLoading(false);

                      setSelectedPlace({
                        ...landMarkData,
                        type: 'landMark',
                        ...distanceAndDuration
                      });
                    }}
                  />
                );
              })
            : null;
        })}
      </GoogleMap>
      {/* show bottom tab */}
      {showLandMarks && (
        <div className={classes?.landMarksContainer}>
          {Object.keys(landMarks).map((landMark) => (
            <div
              key={landMark}
              className={`${classes?.landMark} ${landMarks[landMark] && classes?.selectedLandMark}`}
              onClick={() => {
                if (!landMarksData[landMark].length) getLandMarksData(landMark);
                setLandMarks({ ...landMarks, [landMark]: !landMarks[landMark] });
              }}>
              <img
                src={LAND_MARK_ICON[landMark?.toLocaleLowerCase()]}
                className={classes?.landMarkIcon}
              />
              <label>
                {' '}
                {landMark == 'school'
                  ? 'education'
                  : landMark && landMark == 'hospital'
                  ? 'health'
                  : landMark && landMark == 'bus_station'
                  ? 'commute'
                  : landMark}
              </label>
            </div>
          ))}
        </div>
      )}

      {isLoading && <LottieLoader className={classes?.loaderClass} />}
    </div>
  );
}

function createKey(location) {
  return location.lat + location.lng;
}

// find properties via lat and lng
const findProperties = (lat, lng, arr) => {
  return arr?.find((property) => {
    return (
      property?.location?.coordinates?.[1] === lat && property?.location?.coordinates?.[0] === lng
    );
  });
};

const LAND_MARK_ICON = {
  school: school,
  hospital: hospital, // Assuming 'hotel' represents hospitals in your icons
  park: park,
  business: business,
  market: market, // Add your market icon
  mall: mall, // Add your shopping mall icon
  worship: worship, // Add your places of worship icon
  restaurant: restaurant, // Add your restaurant icon
  cafe: cafe, // Add your cafe icon
  gym: gym, // Add your gym icon
  bus_station: commuteIcon // Add your bus station icon
};
// import {
//   GoogleMap,
//   InfoWindow,
//   Marker,
//   MarkerClusterer,
//   StreetViewPanorama
// } from '@react-google-maps/api';
// import { useRef, useState } from 'react';
// import { FaWalking } from 'react-icons/fa';
// import { MdOutlineSocialDistance, MdOutlineStar } from 'react-icons/md';
// import { getGeocode } from 'use-places-autocomplete';
// import { Get } from '../../Axios/AxiosFunctions';
// import { BaseURL } from '../../config/apiUrl';
// import { defaultLocation } from '../../constant/commonData';
// import {
//   business,
//   cafe,
//   cluster,
//   commuteIcon,
//   gym,
//   hotel,
//   mall,
//   mapMarker2,
//   market,
//   park,
//   restaurant,
//   school,
//   worship
// } from '../../constant/imagePath';
// import EventCard from '../EventCard';
// import LottieLoader from '../LottieLoader/LottieLoader';
// import ProjectCard from '../ProjectCard';
// import PropertyCard from '../PropertyCard';
// import classes from './MainMain.module.css';
// import { useSelector } from 'react-redux';

// const optionsOP = {
//   imagePath:
//     'https://web.archive.org/web/20230701011019/https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m', // so you must have m1.png, m2.png, m3.png, m4.png, m5.png and m6.png in that folder,
//   styles: [
//     {
//       url: cluster,
//       height: 64,
//       width: 64,
//       textColor: 'white',
//       textSize: 14
//     }
//   ]
// };

// const TurkeyBounds = {
//   north: 42.107614,
//   south: 35.808592,
//   west: 25.664641,
//   east: 44.793989
// };

// const isWithinTurkey = (lat, lng) => {
//   return (
//     lat <= TurkeyBounds.north &&
//     lat >= TurkeyBounds.south &&
//     lng >= TurkeyBounds.west &&
//     lng <= TurkeyBounds.east
//   );
// };

// export default function Map({
//   location,
//   className = '',
//   zoom,
//   options = {},
//   isPanorama,
//   mapProperties,
//   setMapProperties,
//   showLandMarks = false,
//   draggable = false,
//   getDraggedAddress,
//   showMarker = true,
//   markerIcon = null
// }) {
//   const { currency } = useSelector((state) => state.converterReducer);
//   const mapRef = useRef(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [selectedPlace, setSelectedPlace] = useState(null);
//   const [landMarks, setLandMarks] = useState({
//     school: false,
//     hospital: false,
//     park: false,
//     business: false,
//     market: false,
//     mall: false,
//     worship: false,
//     restaurant: false,
//     cafe: false,
//     gym: false,
//     bus_station: false
//   });
//   const [landMarksData, setLandMarksData] = useState({
//     school: [],
//     hospital: [],
//     park: [],
//     business: [],
//     market: [],
//     mall: [],
//     worship: [],
//     restaurant: [],
//     cafe: [],
//     gym: [],
//     bus_station: []
//   });

//   // get landMarksData
//   const getLandMarksData = async (type) => {
//     const url = BaseURL(`map?lat=${location.lat}&lng=${location.lng}&type=${type}`);
//     setIsLoading(true);
//     const res = await Get(url);
//     setIsLoading(false);
//     if (res) {
//       // fit bounds
//       const bounds = new window.google.maps.LatLngBounds();
//       res.data?.data.forEach((landMark) => {
//         bounds.extend(landMark?.location);
//       });
//       mapRef.current.fitBounds(bounds);

//       setLandMarksData({ ...landMarksData, [type]: res.data?.data });
//     }
//   };

//   // getDistance between two points: use google maps api
//   const getDistance = async (origin, destination) => {
//     const service = new window.google.maps.DistanceMatrixService();
//     return new Promise((resolve, reject) => {
//       service.getDistanceMatrix(
//         {
//           origins: [origin],
//           destinations: [destination],
//           travelMode: 'WALKING'
//         },
//         (response, status) => {
//           if (status === 'OK') {
//             resolve({
//               distance: response.rows[0].elements[0].distance.text,
//               duration: response.rows[0].elements[0].duration.text
//             });
//           } else {
//             reject('Error was: ' + status);
//           }
//         }
//       );
//     });
//   };
//   const markerIconWidth = 80; // Specify your icon's width
//   const markerIconHeight = 80; // Specify your icon's height
//   return (
//     <div className={`${classes?.container} ${className}`}>
//       {/* Map */}
//       <GoogleMap
//         ref={mapRef}
//         onLoad={(map) => {
//           mapRef.current = map;
//         }}
//         zoom={zoom}
//         center={location}
//         options={{
//           ...options,
//           mapTypeControl: true,
//           fullscreenControl: true
//           // styles: [
//           //   {
//           //     featureType: 'poi',
//           //     elementType: 'labels',
//           //     stylers: [{ visibility: 'off' }]
//           //   }
//           // ]
//         }}
//         mapContainerClassName={classes['map-container']}>
//         {isPanorama && (
//           <StreetViewPanorama
//             position={location}
//             visible={true}
//             options={{
//               // show buttons to move
//               addressControl: true,
//               linksControl: true,
//               panControl: true,
//               enableCloseButton: false,
//               fullscreenControl: true,
//               zoomControl: true,
//               motionTracking: true,
//               motionTrackingControl: true,
//               movementTracking: true,

//               pov: {
//                 heading: 34,
//                 pitch: 10
//               }
//             }}
//           />
//         )}
//         {location && showMarker && (
//           <>
//             <Marker
//               position={location}
//               // icon={markerIcon ? markerIcon : mapMarker2

//               // }
//               icon={{
//                 url: markerIcon ? markerIcon : mapMarker2,
//                 ...(markerIcon
//                   ? {
//                       anchor: new window.google.maps.Point(
//                         markerIconWidth / 2,
//                         markerIconHeight / 2
//                       ), // Center the icon
//                       scaledSize: new window.google.maps.Size(markerIconWidth, markerIconHeight) // Set the size of the icon
//                     }
//                   : {})
//                 // anchor: new window.google.maps.Point(markerIconWidth / 2, markerIconHeight / 2), // Center the icon
//                 // scaledSize: new window.google.maps.Size(markerIconWidth, markerIconHeight) // Set the size of the icon
//               }}
//               draggable={draggable}
//               onDragEnd={(e) => {
//                 // get address [reverse geocoding]
//                 const _location = {
//                   lat: e.latLng.lat(),
//                   lng: e.latLng.lng()
//                 };
//                 // only turkey address
//                 if (isWithinTurkey(_location.lat, _location.lng)) {
//                   getGeocode({ location: _location }).then((results) => {
//                     getDraggedAddress &&
//                       getDraggedAddress({
//                         lat: e.latLng.lat(),
//                         lng: e.latLng.lng(),
//                         address: results[0].formatted_address
//                       });
//                   });
//                   return;
//                 } else {
//                   getDraggedAddress &&
//                     getDraggedAddress({
//                       ...defaultLocation,
//                       address: ''
//                     });
//                 }
//               }}
//             />
//           </>
//         )}

//         {/* render properties on map in a clustered way */}
//         <MarkerClusterer
//           zoomOnClick={false}
//           options={{
//             ...optionsOP
//           }}
//           onClick={(cluster) => {
//             const latLng = cluster.markers.map((marker) => ({
//               lat: marker.getPosition().lat(),
//               lng: marker.getPosition().lng()
//             }));
//             const foundProperties = latLng.map((latLng) =>
//               findProperties(latLng.lat, latLng.lng, mapProperties)
//             );

//             // zoom to bounds
//             const bounds = new window.google.maps.LatLngBounds();
//             foundProperties.forEach((property) => {
//               bounds.extend({
//                 lat: property?.location?.coordinates?.[1],
//                 lng: property?.location?.coordinates?.[0]
//               });
//             });
//             mapRef.current.fitBounds(bounds, 100);

//             setMapProperties && setMapProperties(foundProperties);
//           }}>
//           {(clusterer) =>
//             mapProperties?.map((location) => {
//               const coordinates = {
//                 lat: location?.location?.coordinates?.[1],
//                 lng: location?.location?.coordinates?.[0]
//               };

//               return (
//                 <>
//                   <Marker
//                     label={{
//                       text: ` ${currency?.symbol} ${location.price}`,
//                       fontSize: '14px',
//                       className: classes.customMarkerLabel // Apply styles from MainMain.module.css
//                     }}
//                     onClick={(a) => {
//                       setSelectedPlace(
//                         findProperties(a?.latLng?.lat(), a?.latLng?.lng(), mapProperties)
//                       );
//                       const foundProperty = findProperties(
//                         coordinates.lat,
//                         coordinates.lng,
//                         mapProperties
//                       );
//                       setMapProperties && setMapProperties([foundProperty]);
//                     }}
//                     key={createKey(coordinates)}
//                     position={coordinates}
//                     clusterer={clusterer}
//                     icon={{
//                       url: mapMarker2,
//                       scaledSize: new window.google.maps.Size(0, 0)
//                     }}></Marker>
//                 </>
//               );
//             })
//           }
//         </MarkerClusterer>

//         {/* if selected place, show info window */}
//         {selectedPlace && (
//           <InfoWindow
//             position={{
//               lat: selectedPlace?.location?.coordinates?.[1] || selectedPlace?.location?.lat,
//               lng: selectedPlace?.location?.coordinates?.[0] || selectedPlace?.location?.lng
//             }}
//             onCloseClick={() => setSelectedPlace(null)}>
//             <>
//               <div
//                 style={{
//                   overflow: 'hidden',
//                   // width: '250px',
//                   maxHeight: '403px'
//                 }}>
//                 {selectedPlace?.type === 'event' && <EventCard data={selectedPlace} />}
//                 {selectedPlace?.type === 'property' && <PropertyCard data={selectedPlace} />}
//                 {selectedPlace?.type === 'project' && (
//                   <ProjectCard data={{ ...selectedPlace, map: true }} />
//                 )}
//                 {selectedPlace?.type === 'landMark' && (
//                   <div
//                     style={{
//                       padding: '0 10px 18px'
//                     }}>
//                     <h6 className="t-t-c">{selectedPlace?.name}</h6>
//                     <p className="mb-2 mt-2">{selectedPlace?.address}</p>
//                     <p className="mb-2">
//                       <b>
//                         <MdOutlineStar color="var(--primary-clr)" size={18} />
//                       </b>{' '}
//                       {selectedPlace?.rating}
//                     </p>
//                     <p className="mb-2">
//                       <b>
//                         <MdOutlineSocialDistance color="var(--primary-clr)" size={18} />
//                       </b>{' '}
//                       {selectedPlace?.distance || 'N/A'}
//                     </p>
//                     <p>
//                       <b>
//                         <FaWalking color="var(--primary-clr)" size={18} />
//                       </b>{' '}
//                       {selectedPlace?.duration || 'N/A'}
//                     </p>
//                   </div>
//                 )}
//               </div>
//             </>
//           </InfoWindow>
//         )}

//         {/* render landmarks when visibility is true and length > 0 */}
//         {Object.keys(landMarksData).map((landMark) => {
//           return landMarks[landMark] && landMarksData[landMark] && landMarksData[landMark].length
//             ? landMarksData[landMark].map((landMarkData, index) => {
//                 return (
//                   <Marker
//                     key={index}
//                     position={{
//                       lat: landMarkData?.location?.lat,
//                       lng: landMarkData?.location?.lng
//                     }}
//                     title={landMarkData?.name}
//                     icon={
//                       landMark === 'school'
//                         ? school
//                         : landMark === 'hospital'
//                         ? hotel
//                         : landMark === 'park'
//                         ? park
//                         : landMark === 'market'
//                         ? market
//                         : landMark === 'mall'
//                         ? mall
//                         : landMark === 'worship'
//                         ? worship
//                         : landMark === 'restaurant'
//                         ? restaurant
//                         : landMark === 'cafe'
//                         ? cafe
//                         : landMark === 'gym'
//                         ? gym
//                         : landMark === 'bus_station' // New condition for commute
//                         ? commuteIcon
//                         : business
//                     }
//                     onClick={async () => {
//                       setIsLoading(true);
//                       const distanceAndDuration = await getDistance(location, {
//                         lat: landMarkData?.location?.lat,
//                         lng: landMarkData?.location?.lng
//                       });
//                       setIsLoading(false);

//                       setSelectedPlace({
//                         ...landMarkData,
//                         type: 'landMark',
//                         ...distanceAndDuration
//                       });
//                     }}
//                   />
//                 );
//               })
//             : null;
//         })}
//       </GoogleMap>

//       {/* show bottom tab */}
//       {showLandMarks && (
//         <div className={classes?.landMarksContainer}>
//           {Object.keys(landMarks).map((landMark) => (
//             <div
//               key={landMark}
//               className={`${classes?.landMark} ${landMarks[landMark] && classes?.selectedLandMark}`}
//               onClick={() => {
//                 if (!landMarksData[landMark].length) getLandMarksData(landMark);
//                 setLandMarks({ ...landMarks, [landMark]: !landMarks[landMark] });
//               }}>
//               <img
//                 src={LAND_MARK_ICON[landMark?.toLocaleLowerCase()]}
//                 className={classes?.landMarkIcon}
//               />
//               <label>
//                 {' '}
//                 {landMark == 'school'
//                   ? 'education'
//                   : landMark && landMark == 'hospital'
//                   ? 'health'
//                   : landMark && landMark == 'bus_station'
//                   ? 'commute'
//                   : landMark}
//               </label>
//             </div>
//           ))}
//         </div>
//       )}

//       {isLoading && <LottieLoader className={classes?.loaderClass} />}
//     </div>
//   );
// }

// function createKey(location) {
//   return location.lat + location.lng;
// }

// // find properties via lat and lng
// const findProperties = (lat, lng, arr) => {
//   return arr?.find((property) => {
//     return (
//       property?.location?.coordinates?.[1] === lat && property?.location?.coordinates?.[0] === lng
//     );
//   });
// };

// const LAND_MARK_ICON = {
//   school: school,
//   hospital: hotel, // Assuming 'hotel' represents hospitals in your icons
//   park: park,
//   business: business,
//   market: market, // Add your market icon
//   mall: mall, // Add your shopping mall icon
//   worship: worship, // Add your places of worship icon
//   restaurant: restaurant, // Add your restaurant icon
//   cafe: cafe, // Add your cafe icon
//   gym: gym, // Add your gym icon
//   bus_station: commuteIcon // Add your bus station icon
// };
